import * as S from './styles';
import * as Base from '../styles';
import { Loader } from 'components/Widget/Loader';
import SidebarToggle from 'components/Widget/Button/SidebarToggle';

interface LoadingOverlayProps {
	text?: string;
	// if true, the overlay will be partially see-through
	semiTransparent?: boolean;
}

const LoadingOverlay = ({ text = 'loading...', semiTransparent = false }: LoadingOverlayProps) => {
	return (
		<Base.Base semiTransparent={semiTransparent}>
			{/* <S.SidebarToggleWrapper>
				<SidebarToggle />
			</S.SidebarToggleWrapper> */}
			<Base.Container>
				<S.LoaderWrapper>
					<Loader width={32} height={32} />
				</S.LoaderWrapper>
				<Base.Text>{text}</Base.Text>
			</Base.Container>
		</Base.Base>
	);
};

export default LoadingOverlay;
